import { DecisionGraph, type RawRuleGraph } from "@imminently/decisively-core";
import { isTemporal } from "../../pages/decisions/DecisionDashboard/Reports/Details/UnifiedTimeline/types";
import { mergeValueAndDatesFilter } from "./DatesFilter_mergeValueAndDatesFilter";
import type { Props as DatesFilterProps } from "./DatesFilter_types";

export const parseRawGraph = (
  rawGraph: RawRuleGraph | Uint8Array | DecisionGraph,
  datesFilter?: DatesFilterProps["value"],
): DecisionGraph => {
  const [start, end] = datesFilter || [null, null];

  // if empty object, return empty graph
  if (!rawGraph || (!(rawGraph instanceof DecisionGraph) && Object.keys(rawGraph).length === 0)) {
    return new DecisionGraph();
  }

  const graph = DecisionGraph.from(rawGraph as any);
  if (start !== null && end !== null) {
    // DecisionGraph.from answers the same graph for the same input: filter a copy
    const filtered = graph.clone();
    for (const id of filtered.ids()) {
      const derived = filtered.field(id, "derived") as any;
      if (isTemporal(derived)) filtered.node(id)!.derived = mergeValueAndDatesFilter(derived, datesFilter);
    }
    return filtered;
  }

  return graph;
};
